<template>
  <div class="defaultUpload StoriesEdit">
    <template v-if="page == 'default'">
      <h2>Редактировать рассказ</h2>

      <ElemInput
        valueName="title"
        @changeValue="changeValue"
        :valueProp="title"
        label="Заголовок"
      />

      <button @click="openPickImage = true" type="button" class="addTitleImage">
        Титульное изображение
      </button>

      <img
        class="titleImage"
        v-if="ImageTitle"
        :src="baseUrl + 'storage/images/' + ImageTitle"
      />

      <PickGallery v-if="openPickImage" @pickImage="pickImage" />

      <ElemTextarea
        valueName="shortDescription"
        @changeValue="changeValue"
        :valueProp="shortDescription"
        label="Краткое описание"
      />
      
      <TextEditor v-model:modelValue="description" />

      <ElemInput
        valueName="author"
        @changeValue="changeValue"
        :valueProp="author"
        label="Автор"
      />
      <ElemSelect
        valueName="status"
        @changeValue="changeValue"
        :valueProp="status"
        label="Статус"
        :options="statusOptions"
      />

      <ElemInput
        valueName="price"
        @changeValue="changeValue"
        :valueProp="price"
        label="Цена"
      />

      <div class="chapters">
        <span class="chapters-title">Главы</span>

        <div class="chapters-list" v-if="chapters && chapters.length">
          <div class="chapters-link" v-for="(model, key) in chapters" :key="key">
            <span
              class="chapters-link-title"
              @click="editChapter(model.id)"
              >{{ model.title }} ({{ model.order }})</span
            >
            <button
              type="button"
              @click="deleteChapterLoc(model.id)"
            >
              Удалить
            </button>
          </div>
        </div>
        <p v-else class="chapters-empty">Глав пока нет</p>

        <button
          type="button"
          class="chapters-add"
          @click="page = 'addChapter'"
        >
          Добавить главу
        </button>
      </div>

      <router-link
        class="preview-link"
        :to="{ name: 'stories-preview', params: { id: id } }"
      >
        <span>Предварительный просмотр</span>
      </router-link>

      <TextEditor v-model:modelValue="text" />

      <div class="form-actions">
        <button class="update" type="button" v-on:click="updateStory">
          Обновить
        </button>
        <button class="delete" type="button" v-on:click="deleteStory">
          Удалить
        </button>
      </div>
    </template>
    <AddChapter
      @created="chapterCreated"
      v-if="page == 'addChapter'"
      :storiesId="id"
    />
    <EditChapter
      @updated="chapterCreated"
      v-if="page == 'editChapter'"
      :storiesId="id"
      :id="chapterId"
    />
  </div>
</template>

<script>
import TextEditor from "@/components/TextEditor.vue";
import ElemInput from "@/components/elements/elemInput";
import ElemSelect from "@/components/elements/elemSelect";
import stories from "@/composables/views/stories.ts";
import chaptersComp from "@/composables/views/stories-chapters.ts";
import PickGallery from "@/components/gallery/PickGallery";
import ElemTextarea from "@/components/elements/elemTextarea";
import AddChapter from "@/components/stories/chapters/AddChapter";
import EditChapter from "@/components/stories/chapters/EditChapter";

export default {
  name: "StoriesEdit",
  setup() {
    const {
      getStory,
      deleteStory,
      updateStory,
      baseUrl,
      id,
      title,
      shortDescription,
      description,
      text,
      author,
      status,
      statusOptions,
      ImageTitle,
      openPickImage,
      chapters,
      price,
    } = stories();

    const { deleteChapter } = chaptersComp();

    return {
      getStory,
      deleteStory,
      updateStory,
      baseUrl,
      id,
      title,
      shortDescription,
      description,
      text,
      author,
      status,
      statusOptions,
      ImageTitle,
      openPickImage,
      chapters,
      deleteChapter,
      price,
    };
  },
  data() {
    return {
      page: "default",
      chapterId: null,
    };
  },
  components: {
    TextEditor,
    PickGallery,
    ElemInput,
    ElemSelect,
    ElemTextarea,
    AddChapter,
    EditChapter,
  },
  mounted: function () {},
  async created() {
    this.getStory();
  },
  methods: {
    async deleteChapterLoc(id) {
      await this.deleteChapter(id);
      await this.getStory();
    },
    editChapter(id) {
      this.chapterId = id;
      this.page = "editChapter";
    },
    chapterCreated() {
      this.page = "default";
      this.getStory();
    },
    changeValue(valueName, value) {
      this[valueName] = value;
    },
    pickImage(image) {
      this.ImageTitle = image;
      this.openPickImage = false;
    },
  },
};
</script>